export const removeDuplicateObjectsFromArray = (array) =>
	array?.filter(
		(value, index, self) => index === self.findIndex((t) => t.place === value.place && t.name === value.name)
	);
